<template>
  <li draggable="true" @dragstart="onDragStart($event, item)">
    <div
      :class="['viewingDisciplineName', { folderActive: selectedItemCheck }]"
      @click="toggle($event)"
    >
      <i
        :class="[isOpen ? 'fas fa-folder-open' : 'fas fa-folder']"
        v-if="isFolder"
      ></i>
      <a
        class="viewingDisciplineName__link"
        :href="item.body"
        :download="item.lable"
        target="blank"
        v-if="isFile"
        ><i :class="iconItem"></i>
        <p>{{ item.lable }}<span></span></p
      ></a>
      <i class="fas fa-code" v-if="isTemplate"></i>
      <p v-if="!isFile">
        {{ isTemplate ? `HTML ${getHeaderTemplate(item.body)}` : item.lable }}
      </p>
      <!-- <el-checkbox
        v-if="!isScorm && ((isFile && !readOnly) || (!treeVideo && !readOnly))"
        :value="selectedItemCheck"
        @change="selectItem($event)"
      ></el-checkbox> -->
    </div>
    <ul
      class="viewing-discipline-section__list"
      v-show="isOpen"
      v-if="isFolder"
    >
      <tree-item
        class="discipline-item"
        v-for="(child, index) in item.children"
        :key="index"
        :readOnly="readOnly"
        :item="child"
      ></tree-item>
      <i class="el-icon-loading" v-if="loadingContent"></i>
      <li v-if="isFolder && !item.children.length && !loadingContent">
        Содержимое отсутствует
      </li>
    </ul>
  </li>
</template>

<script>
import Autolinker from 'autolinker';

export default {
  name: "tree-item",
  props: {
    item: Object,
    readOnly: Boolean,
    title: String,
  },
  data() {
    return {
      redirectLink: null,
      isScorm: false,
      loadingContent: false,
      iconItem: "",
      activeMenu: false,
      nameFolder: "",
      isOpen: false,
      icons: {
        directory: "fas fa-folder-open",
        pdf: "far fa-file-pdf",
        doc: "fas fa-file-word",
        docx: "fas fa-file-word",
        mp4: "fas fa-file-video",
      },
    };
  },

  computed: {
    treeVideo() {
      return this.item.execution === "video-tree" ? true : false;
    },
    selectedItemCheck() {
      return this.selectedItem
        ? this.selectedItem.path === this.item.path
        : false;
    },
    selectedItem() {
      return this.$store.state.viewingDiscipline.selectedItem;
    },
    isFolder() {
      return this.item.children ? true : false;
    },
    isFile() {
      return this.item.type === "file";
    },
    isTemplate() {
      return this.item.type === "template";
    },
    isRoot() {
      return this.item.type === "root";
    },
  },
  methods: {
    getHeaderTemplate(value) {
      let tag = value.match(/<(h1|strong).*?>*?<\/(h1|strong)>/i);
      if (!tag) {
        return "";
      } else {
        let tagContent = tag[0].match(/>(.*)</);
        return tagContent[1];
      }
    },
    selectItem(e) {
      if (e) {
        this.$store.commit("setSelectedItem", this.item);
      } else {
        this.$store.commit("setSelectedItem", null);
      }
    },
    onDragStart(e, item) {
      e.stopPropagation();
      e.dataTransfer.dropEffect = "move";
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("itemPath", item.path.toString());
    },

    setType() {
      if (this.isTemplate) {
        const RegExpScormLink = /href="\/course\/player\/play.php\?discpl=(\d{2,})/;
        const RegExpScorm = /href="\/course\/player/;
        const RegExpOnlineCourse = /href="\/discipline\/course\/\d+\/(.+)\/res\/index.html/

        if (this.item.body.match(RegExpScorm)) {
          this.isScorm = true;

          if (this.item.body.match(RegExpScormLink)) {
            this.redirectLink = this.item?.body?.match(RegExpScormLink)?.[0]?.substring(6);
          }
          
          return;
        }

        if(this.item.body.match(RegExpOnlineCourse)) {
          this.redirectLink = this.item?.body?.match(RegExpOnlineCourse)?.[0]?.substring(6);
        }
      }
    },
    toggle() {
      if (this.isFolder) {
        if (this.treeVideo && !this.isOpen && !this.item.children.length) {
          let newPeth = { path: this.item.path };
          this.loadingContent = true;
          this.axios
            .post(
              `api/disciplines/${this.$route.params.did}/v-store/next`,
              newPeth
            )
            .then((res) => {
              this.loadingContent = false;
              if (res.data.status) {
                this.item.children = res.data.menu;
              }
            });
        }
        this.isOpen = !this.isOpen;
        return
      } else if (this.isTemplate && this.readOnly && !this.isScorm) {
        this.$store.commit("setSelectedItem", this.item);
        this.$store.commit("setHtmlEditorActive", true);
        return
      } else if (this.redirectLink) {
        window.open(`https://spo.instudy.online${this.redirectLink}`);
      }
    },
    setItemIcon() {
      for (let key in this.icons) {
        key === this.item.extension ? (this.iconItem = this.icons[key]) : null;
      }
      this.iconItem ? null : (this.iconItem = "fas fa-file-alt");
    },
  },
  mounted() {
    this.setType();
    this.setItemIcon();
  },
};
</script>

<style lang="scss">
.viewingDisciplineName {
  margin: 5px;
  transition-property: background-color;
  transition-duration: 0.3s;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  max-width: 100%;
  cursor: pointer;
  &:hover {
    background-color: $extra-light-border;
    .viewing-discipline__input-name {
      background-color: $extra-light-border;
    }
  }
  .folderActive {
    background-color: $brand-clr-1;
    color: $basic-white;
    &:hover {
      background-color: lighten($color: $brand-clr-1, $amount: 10%);
    }
    i {
      color: $basic-white;
    }
    p {
      color: $basic-white;
    }
  }
  .el-icon-close {
    color: $danger-clr;
  }
  .el-icon-circle-close,
  .el-icon-circle-check {
    font-size: 18px;
  }
  .fa-file-video,
  .fa-code,
  .fa-file-word,
  .fa-file-pdf,
  .fa-folder-open,
  .fa-folder,
  .fa-file-alt {
    transition-duration: 0.3s;
    transition-property: color;
    color: $brand-clr-1;
    font-size: 20px;
    padding-right: 10px;
  }
  .fa-file-video {
    color: $danger-clr;
  }
  .fa-code {
    color: $success-clr;
  }
  .fa-file-pdf {
    color: red;
  }
  .fa-file-alt {
    color: $warning-clr;
  }
  .inputIsActive {
    border-bottom: 1px solid $base-border-clr;
  }
  p {
    //word-break:break-all;
    width: 100%;
    margin: 0;
    text-align: left;
  }
  .el-checkbox__inner {
    margin-left: 15px;
    border-color: $brand-clr-1;
    z-index: 0;
  }
  &__link {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
